import $ from 'jquery';

const customSelect = {
	customSelect(selector) {
		$( selector ).each(
			function(){

				var $this = $( this ), numberOfOptions = $( this ).children().length;
				if(selector === '.custom-select') {
					$this.find( 'option:first-child' ).attr( 'value', 'hide' );
				}
				$this.addClass( 'select-hidden' );
				$this.wrap( '<div class="select"></div>' );
				$this.after( '<div class="select-styled"></div>' );

				var label = $this.attr( 'data-label' );
				if (label) {
					$this.before( ` < div class = "select-label" > ${label} < / div > ` );
				}

				var $styledSelect = $this.next( 'div.select-styled' );
				if(selector === '.custom-select') {
					$styledSelect.text( $this.children().eq( 0 ).text() );
				} else {
					$styledSelect.text( $this.find(":selected").text() );
				}


				var $list = $(
					'<ul />',
					{
						'class': 'select-options'
					}
				).insertAfter( $styledSelect );

				for (var i = 0; i < numberOfOptions; i++) {
					if(!$this.children().eq( i ).attr('disabled')) {
						$(
							'<li />',
							{
								html: $this.children().eq( i ).html(),
								rel: $this.children().eq( i ).val(),
								class: $this.children().eq( i ).attr('class'),
								value: $this.children().eq( i ).html(),
								category: $this.children().eq( i ).attr('data-category'),
								'data-obligation': $this.children().eq( i ).attr('data-obligation-link'),
								disabled:$this.children().eq( i ).attr('disabled')
							}
						).appendTo( $list );
					}

				}

				var $listItems = $list.children( 'li' );

				$styledSelect.click(
					function(e) {
						e.stopPropagation();
						$( 'div.select-styled.active' ).not( this ).each(
							function(){
								$( this ).removeClass( 'active' ).next( 'ul.select-options' ).hide();
							}
						);
						$( this ).toggleClass( 'active' ).next( 'ul.select-options' ).toggle();
					}
				);

				$listItems.each(function () {
					$(this).wrapInner('<span class="select-options__text"></span>')
				})

				$listItems.click(
					function(e) {
						e.stopPropagation();
						$styledSelect.text( $( this ).attr('value') ).removeClass( 'active' );
						$styledSelect.addClass( 'selected' );
						$this.val( $( this ).attr( 'rel' ) );
						$list.hide();
						$this.trigger( 'change' );
						//console.log($this.val())
					}
				);

				$( document ).click(
					function() {
						$styledSelect.removeClass( 'active' );
						$list.hide();
					}
				);

			}
		);
	}

}

export default customSelect;
